import { DbgPaths } from "../../../../../utils/Paths"
import { ModalListItem } from "../ModalListItem"
import React from "react"
import DefaultMarkdown from "../../../DefaultMarkdown"

export const MedicationsHeader = (): JSX.Element => {
  return (
    <p>
      <DefaultMarkdown source={"This category includes eligible medications for the following journeys:"} />
    </p>
  )
}

export const MedicationListItems = (benefitInfo): JSX.Element => {
  const journeys = benefitInfo.benefitInfo.journeys
  return (
    <>
      {journeys.fertilityCare.eligibleExpensesDetail.isRxCovered && (
        <ModalListItem>
          <DefaultMarkdown source={"[Fertility care](" + DbgPaths.FERTILITY_COVERAGE + ")"} />
        </ModalListItem>
      )}
      {journeys.fertilityPreservation.eligibleExpensesDetail.isRxCovered && (
        <ModalListItem>
          <DefaultMarkdown source={"[Fertility preservation](" + DbgPaths.PRESERVATION_COVERAGE + ")"} />
        </ModalListItem>
      )}
      {journeys.fertilityCare.eligibleExpensesDetail.hasDonorAssistance && (
        <ModalListItem>
          <DefaultMarkdown
            source={"[Donor assistance](" + DbgPaths.FERTILITY_COVERAGE + ") related to fertility care"}
          />
        </ModalListItem>
      )}
      {journeys.gestationalCarrier.hasEligibleExpenses && (
        <ModalListItem>
          <DefaultMarkdown
            source={
              "[Gestational surrogacy](" + DbgPaths.GESTATIONAL_SURROGACY_COVERAGE + ") and related donor assistance"
            }
          />
        </ModalListItem>
      )}
      {journeys.menopause.hasEligibleExpenses && (
        <ModalListItem>
          <DefaultMarkdown source={"[Menopause](" + DbgPaths.MENOPAUSE + ")"} />
        </ModalListItem>
      )}
      {journeys.lowTestosterone.hasEligibleExpenses && (
        <ModalListItem>
          <DefaultMarkdown source={"[Low testosterone](" + DbgPaths.LOW_TESTOSTERONE + ")"} />
        </ModalListItem>
      )}
      {journeys.genderAffirmingCare.hasEligibleExpenses && (
        <ModalListItem>
          <DefaultMarkdown source={"[Gender-affirming care](" + DbgPaths.GENDER_AFFIRMING_CARE + ")"} />
        </ModalListItem>
      )}
    </>
  )
}

export const MedicationsFooter = (benefitInfo): JSX.Element => {
  const carrotRx = benefitInfo.benefitInfo.carrotRx

  return (
    <p>
      {carrotRx.isCarrotRxRequired ? (
        <DefaultMarkdown
          source={
            "To be covered, all medications must be prescribed by an [eligible provider](" +
            DbgPaths.PROVIDER_ELIGIBILITY +
            ")" +
            " and filled through [Carrot Rx](" +
            DbgPaths.CARROT_RX +
            ")."
          }
        />
      ) : (
        <DefaultMarkdown
          source={
            "To be covered, all medications must be prescribed by an [eligible provider](" +
            DbgPaths.PROVIDER_ELIGIBILITY +
            ")."
          }
        />
      )}
    </p>
  )
}
